module.exports = __webpack_public_path__ + "img/red-down-arrow.52f90bd2254e24230170e27a8b50f853.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red-down-arrow.svg
// module id = 477
// module chunks = 0